<template>
  <Modal @close="close">
    <template v-slot:header>
      {{ isPinStep ? "Telefone celular" : "Verificar telefone" }}
    </template>
    <template v-slot:body>
      <div v-if="!isLoading">
        <div v-if="isPinStep" class="pin-step">
          <p class="pin-step-message">Insira o código enviado por SMS.</p>
          <p
            class="maskedNumber"
            v-html="maskedPhoneNumber || OTPPhoneNumber"
          ></p>
          <PINInput ref="pinRef" v-model="otpValue" @filled="handleSubmit" />
        </div>
        <div class="otp-content" v-if="!isPinStep">
          <b-input
            name="phoneNumber"
            v-model="OTPPhoneNumber"
            placeholder="DDD + Número do celular"
            v-cleave="masks.longCellphone"
            @input.native="cleaveRefresh"
            @keyup.enter.native="handleSubmit"
            autocomplete="off"
            ref="cellPhoneNumber"
          />
          <p class="otp-warning">
            Ao continuar, você receberá um SMS com um código de confirmação.
          </p>
        </div>
      </div>
      <div v-if="isLoading" class="loading-container">
        <b-loading :is-full-page="false" :active.sync="isLoading" />
      </div>
    </template>
    <template v-if="!isLoading" v-slot:footer>
      <b-button
        type="is-primary"
        :disabled="
          (!isPinStep && OTPPhoneNumber.replace(/\D/g, '').length < 11) ||
          (isPinStep && otpValue.length !== 4)
        "
        @click.prevent="handleSubmit"
        >Continuar</b-button
      >
    </template>
  </Modal>
</template>

<script>
import Vue from "vue";
import config from "config";

import { getIdentifierHeaders } from "@zuldigital/utils";
import Modal from "../layout/Modal";
import cleave, { cleaveRefresh, masks } from "../directives/cleave.js";
import PINInput from "./PINInput";
import user from "../services/user";
import signup from "../services/signup";

import API from "../services/http";

export default {
  name: "OTPValidation",
  components: {
    Modal,
    PINInput,
  },
  props: ["maskedPhoneNumber", "userData"],
  data() {
    return {
      isPinStep: false,
      loginOPTResponseError: {},
      isOTPModalVisible: false,
      OTPPhoneNumber: "",
      masks,
      cleaveRefresh,
      otpValue: "",
      isLoading: false,
      shouldSignUp: false,
    };
  },
  directives: {
    cleave,
  },
  watch: {
    isOTPModalVisible: function (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.focusCellPhoneNumberInput();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    checkStep(newMaskedPhoneNumberValue, shouldSignUp = false) {
      this.shouldSignUp = shouldSignUp;

      this.$nextTick(() => {
        if (this.$refs.pinRef) {
          this.$refs.pinRef.clear();
        }

        this.OTPPhoneNumber = "";
      });

      if (newMaskedPhoneNumberValue) {
        this.isLoading = true;

        user
          .requestOtp(undefined)
          .then((response) => {
            Vue.auth.token("access_token", response.headers["x-auth-token"]);

            this.isPinStep = true;
            this.isLoading = false;
          })
          .catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message ||
              "Ocorreu um erro inesperado, Por favor tente novamente em instantes";

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });

            this.close();
            this.isLoading = false;
          });
      } else {
        this.isPinStep = false;
      }
    },
    focusCellPhoneNumberInput() {
      if (this.$refs.cellPhoneNumber) {
        this.$refs.cellPhoneNumber.getElement("input").focus();
      }
    },
    phoneNumberSubmit() {
      const phoneNumber = this.OTPPhoneNumber.replace(/\D/g, "");

      if (phoneNumber.length === 11) {
        this.isPinStep = true;
        this.isLoading = true;

        user
          .requestOtp(`+55${phoneNumber}`)
          .then((response) => {
            Vue.auth.token("access_token", response.headers["x-auth-token"]);

            this.isLoading = false;
          })
          .catch((error) => {
            const message =
              (((error || {}).response || {}).data || {}).message ||
              "Ocorreu um erro inesperado, Por favor tente novamente em instantes";

            this.$buefy.toast.open({
              message,
              type: "is-danger",
            });

            this.isPinStep = false;
            this.isLoading = false;
          });
      } else {
        // showError
      }
    },
    handleLoginError(error) {
      const status = ((error || {}).response || {}).status;
      let message = "";

      switch (status) {
        case 406:
          message = "Código incorreto!";
          break;

        case 417:
          signup
            .signup()
            .then(() => {
              this.login();
            })
            .catch(() => {
              this.$buefy.toast.open({
                message: message,
                type: "is-danger",
              });
            });

          break;

        default:
          message = "Ocorreu um erro de sistema ao tentar efetuar o acesso.";
          break;
      }

      this.$buefy.toast.open({
        message,
        type: "is-danger",
      });

      this.isLoading = false;
    },
    async handleLoginSuccess(response) {
      this.isLoading = false;

      this.$auth.watch.authenticated = true;
      this.$auth.watch.loaded = true;
      this.$auth.user(response.data);

      if (this.shouldSignUp) {
        try {
          this.isLoading = true;

          await signup.signup();
          await new Promise((resolve) => setTimeout(resolve, 2000));

          this.$router.push("/");

          this.isLoading = false;
        } catch (error) {
          const message =
            (((error || {}).response || {}).data || {}).message ||
            "Ocorreu um erro inesperado, Por favor tente novamente em instantes";

          this.$buefy.toast.open({
            message,
            type: "is-danger",
          });
        }
      } else {
        this.$router.push("/");
      }
    },
    doLogin() {
      this.isLoading = true;

      const formattedPhoneNumber = this.OTPPhoneNumber.replace(/\D/g, "");
      const data = new FormData();

      data.append("otp", this.otpValue);

      if (formattedPhoneNumber) {
        data.append("phoneNumber", formattedPhoneNumber);
      }

      API.post(`${config.ZUL_API_URL}/auth/login`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ...getIdentifierHeaders(),
          Authorization: `Bearer ${Vue.auth.token("access_token")}`,
          "X-Origin": "WEB_APP",
          "X-City": localStorage.getItem("X-City"),
        },
      })
        .then(this.handleLoginSuccess)
        .catch(this.handleLoginError);
    },
    handleSubmit() {
      if (!this.isPinStep) {
        this.phoneNumberSubmit();
      } else {
        this.doLogin();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pin-step-message {
  margin-bottom: 20px;
}

.otp-warning {
  margin-top: 20px;
}

.otp-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  > .control {
    width: 90%;

    > input {
      background-color: transparent;
      box-shadow: none;
      outline: none;
      border: none;
      color: #fff;
      border-radius: 0;
      padding: 0;

      &::placeholder {
        color: #fff;
      }
    }
  }

  > p {
    text-align: center;
    width: 90%;
  }
}

.pin-step {
  width: 90%;
  margin: 0 auto;
  text-align: center;

  .maskedNumber {
    font-size: 21px;
    font-weight: 700;
    margin-bottom: 10px;
  }
}

.loading-container {
  height: 100px;
}
</style>
<style lang="scss">
.loading-container {
  .loading-background {
    background: transparent;
  }
}
</style>
